/* APP */
import 'popper.js';
import 'bootstrap';
import '@fortawesome/fontawesome-pro/js/all';
import { Map } from './map';
import _ from 'underscore';
import 'clndr';
import moment from 'moment';
import './app-form';

/* WADCMS */
// A décommenter si vous utilisez WadCms
import '../../vendor/wad-commons/wad-cms/assets/js/app-cms';
import '../../vendor/wad-commons/wad-admin/asset/plugins/jquery-ui/jquery-ui';
import '../../vendor/wad-commons/wad-admin/asset/plugins/jquery-ui/ui/i18n/datepicker-fr';

/* WADGALLERY */
// A décommenter si vous utilisez WadGallery
import '../../vendor/wad-commons/wad-gallery/assets/js/app-gallery';

import '../../module/WadRGPD/assets/js/wad-rgpd';

$(document).ready(function(){
  $('.form-secteur').change(function() {
    $( "#form-filter" )[0].submit();
  });

  $.datepicker.setDefaults($.datepicker.regional['fr']);
  $.datepicker.setDefaults({ dateFormat: 'yy-mm-dd' });
;
  $('.date-design').datepicker({
    changeMonth: true,
    changeYear: true,
    showButtonPanel: true,
    yearRange: "-90:-12",
    defaultDate: "-18Y"
  });

  $('.date-18').datepicker({
    changeMonth: true,
    changeYear: true,
    showButtonPanel: true,
    yearRange: "-80:-17",
    minDate: "-80Y",
    maxDate: "-18Y"
  });

  // MOMENT
  moment().format();
  moment.locale('fr');

  // CLNDR
  let dataTagAgenda = document.getElementById('data-cms-clndr');
  if (dataTagAgenda){
    window._ = _; // Underscore est passé en var global pour le rendu du clndrTemplate
    let data = JSON.parse(dataTagAgenda.innerHTML);
    let clndrTemplate =
    '<div class="clndr-controls">' +
      '<div class="clndr-control-button">' +
        '<span class="clndr-previous-button"><i class="far fa-chevron-left"></i></span>' +
      '</div>' +
      '<div class="month"><%= month %> <%= year %></div>' +
      '<div class="clndr-control-button">' +
        '<span class="clndr-next-button"><i class="far fa-chevron-right"></i></span>' +
      '</div>' +
    '</div>' +
    '<div class="clndr-grid">' +
        '<div class="days-of-the-week">' +
        '<% _.each(daysOfTheWeek, function (day) { %>' +
            '<div class="header-day"><%= day %></div>' +
        '<% }); %>' +
          '<div class="days">' +
            '<% _.each(days, function (day) { %>' +
              '<div class="<%= day.classes %> <% _.each(day.events, function (event) { %> bg-<%= event.color %> <% }) %>">' +
                '<span class="day-value">' + // Ancien tooltip : data-toggle="tooltip" data-placement="top" title="<% _.each(day.events, function (event) { %> <i class=\'far fa-calendar-day mr-1\'></i> <%= event.name %><br> <% }) %>"

                  '<% if (day.day) { %>' +
                    '<%= day.day %>' +
                  '<% } else { %>' +
                    '0' +
                  '<% } %>' +

                  '<% if (day.events.length > 0) { %>' +
                    '<span class="day-tooltip">' +
                      '<% _.each(day.events, function (event) { %> <i class=\'far fa-calendar-day mr-1\'></i> <%= event.name %><br> <% }) %>' +
                    '</span>' +
                  '<% } %>' +

                '</span>' +
              '</div>' +
            '<% }); %>' +
          '</div>' +
        '</div>' +
    '</div>';

    let daysOfTheWeek = ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa','Di'];
    let agendas = data.agendas;
    let events = [];
    agendas.forEach((agenda)=>{
      events.push(
        {
          idAgenda: agenda.idAgenda,
          name: agenda.name,
          date: agenda.dateBegin,
          color: agenda.color,
          url: agenda.url,
        }
      );
    })

    let clndrOptions = {
      template: clndrTemplate,
      daysOfTheWeek: daysOfTheWeek,
      showAdjacentMonths: false,
      events: events,
      clickEvents: {
        click: function (target) {
          if (target.events && target.events.length > 0){
            document.location.href = target.events[0].url;
          }
        },
        onMonthChange: function (month) {
          if (data.url.eventsByMonth){
            $.ajax({
              url: data.url.eventsByMonth + '/' + (month.month() + 1),
              data : {
                year : month.year()
              },
              success: function(response){
                let agendas = response.agendas;
                cmsClndr.setEvents(agendas);
                /*
                let falseEvents = [
                  {
                    idAgenda:1000,
                    name: "TEST FALSE EVENT",
                    date: "2019-08-19",
                    color: "primary",
                    url: "https://www.webadev.com",
                  }
                ];
                cmsClndr.setEvents(falseEvents);
                */
              }
            })
          }
        },
      },
      moment: moment
    };

    let cmsClndr = $('.cms-clndr').clndr(clndrOptions);

    // TOOLTIPS
    //$('.day-value').tooltip({html:true});
  }

  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
  }

  // GOOGLE MAP
  // Places
  let mapPlaceElement = document.getElementById('placemap');
  if (mapPlaceElement){
    Map.loadGoogleMapsApi().then(function(googleMaps) {
      let map = Map.createMap(googleMaps, mapPlaceElement);
      let dataTag = document.getElementById('data-places');
      if (dataTag){
        let data = JSON.parse(dataTag.innerHTML);
        let places = data.places;
        places.forEach((place) => {
          Map.addMarker(googleMaps, map, place);
        })
      }
    });
  }

  // Place consult
  let mapPlaceConsultElement = document.getElementById('placeconsultmap');
  if (mapPlaceConsultElement){
    Map.loadGoogleMapsApi().then(function(googleMaps) {
      let dataTag = document.getElementById('data-place-consult');
      if (dataTag){
        let data = JSON.parse(dataTag.innerHTML);
        let place = data.place;
        let latLng = {lat:place.latitude,lng:place.longitude};
        let map = Map.createMap(googleMaps, mapPlaceConsultElement, latLng, 17);
        Map.addMarker(googleMaps, map, place);
      }
    });
  }

  // NAVBAR ACTIVE
  let navItemClasses = ['active-blue','active-lilas','active-orange','active-red','active-yellow','active-yellow2'];
  addRandomForm($('.nav-item.active'),true);

  // NAVBAR HOVER
  $('.navbar .nav-item').hover(function(){
    addRandomForm($(this));
  },function(){
    deleteRandomForm($(this));
  });

  function addRandomForm(el,active){
    if (!el.hasClass('active') || active){
      el.addClass(navItemClasses[Math.floor(Math.random()*navItemClasses.length)]);
    }
  }

  function deleteRandomForm(el){
    if (!el.hasClass('active')){
      navItemClasses.forEach((activeClass)=>{
        el.removeClass(activeClass);
      })
    }
  }

  // NAVBAR DROPDOWN

  let size = 1200;

  // if ($(window).width() >= size)
  $("#navbar .dropdown .nav-link").on("mouseenter", function () {
    if ($(window).width() >= size){
      $(this).parent().addClass('show');
      let dropdown = $('+.dropdown-menu',this);
      dropdown.addClass('show');
      if (!$(this).parent().hasClass("show")) {
        $(this).click();
      }
    }
  });

  $("#navbar .dropdown").on("mouseleave", function () {
    if ($(window).width() >= size){
      let navLink = $(this).find('.nav-link').parent();
      let menu = $(this).find('.dropdown-menu');
      navLink.removeClass('show');
      menu.removeClass('show');
    }
  });

  $("#navbar .btn-group, .dropdown").on("mouseleave", function () {
    if ($(window).width() >= size){
      if ($(this).hasClass("show")){
        $(this).children('.nav-link').first().click();
      }
    }
  });

  $('#navbar .dropdown-item').hover(function (){
    let dropdownMenu = $('+.dropdown-menu',this);
      if (dropdownMenu && dropdownMenu.length > 0 && (dropdownMenu.offset().left + dropdownMenu.width()) >= $(window).width()){
        dropdownMenu.addClass('dropdown-menu-right dropdown-menu-overflow');
      }
  });

  // if ($(window).width() < size)
  $("#navbar .dropdown .nav-link").on("click", function (e) {
    if ($(window).width() < size){
      e.preventDefault();
      $(this).toggleClass('show');
      $('+.dropdown-menu',this).toggleClass('show');
    }
  });

  // BIG NUMBERS
  let bigNumbers = $('.bigNumber');
  let incremented = false;
  if (bigNumbers.length > 0){
    testIncrement(); // init
    $(window).scroll(function () {
      testIncrement();
    });
  }

  function testIncrement(){
    if (!incremented){
      let scroll = $(window).scrollTop() + $(window).height();
      $('.bigNumber').each((i,element) => {
        if(scroll >= ($(element).offset().top)){
          let finalVal = element.innerHTML;
          element.innerHTML = 0;

          let incrementValue = 1;
          let timeout = 100;

          if (finalVal > 10){
            timeout = 50;
          }

          if (finalVal > 50){
            timeout = 20;
          }

          if (finalVal > 1000){
            timeout = 10;
            incrementValue = 2;
          }

          if (finalVal > 2000){
            timeout = 1;
            incrementValue = 5;
          }

          increment(element,finalVal, timeout, incrementValue);
          incremented = true;
        }
      })
    }
  }

  function increment(element, finalVal, timeout, incrementValue) {
    let currVal = parseInt(element.innerHTML, 10);
    if (currVal < finalVal) {
      currVal += incrementValue;
      element.innerHTML = currVal;

      setTimeout(function() {
        increment(element,finalVal, timeout, incrementValue);
      }, timeout)
    }
  }
  /*
  if(document.getElementById('state') && document.getElementById('document-entreprise-show')) {
    updateStateDocument();
    document.getElementById('state').addEventListener('change', function () {
      updateStateDocument();
    });
  }

  function updateStateDocument() {
    //get value of select element with id state
    let state = document.getElementById('state').value;
    if(state == 5) {
        document.getElementById('document-entreprise-show').classList.remove('d-none');
    } else {
        document.getElementById('document-entreprise-show').classList.add('d-none');
    }
  }*/

});
